import React, { useEffect, useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Public banner shown on the marketing landing page above the pricing grid.
 * Fetches /api/pricing/founding-seats (unauthenticated) and shows a live counter.
 * Hides itself when the program is sold out (remaining === 0).
 */
export default function FoundingBanner() {
  const { user } = useAuth();
  const [seats, setSeats] = useState(null);
  const backend = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetch(`${backend}/api/pricing/founding-seats`)
      .then((r) => r.json()).then(setSeats).catch(() => {});
  }, [backend]);

  if (!seats || seats.remaining === 0) return null;

  const cta = () => (window.location.href = user ? "/dashboard/billing?founding=1" : "/signup?founding=1");

  return (
    <section className="max-w-5xl mx-auto px-6 md:px-12 -mt-8 mb-4" data-testid="founding-banner">
      <div className="relative overflow-hidden rounded-2xl border border-lime-400/60 bg-gradient-to-br from-emerald-950 via-emerald-900 to-emerald-950 p-6 md:p-8 text-white shadow-xl shadow-emerald-950/20">
        <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-lime-400/10 blur-2xl" />
        <div className="absolute -bottom-6 -left-6 h-24 w-24 rounded-full bg-lime-400/10 blur-2xl" />
        <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-lime-300">
              <Sparkles className="h-3.5 w-3.5" /> BidMatchAI Founding 100 · Limited
            </div>
            <h3 className="mt-2 font-heading text-2xl sm:text-3xl font-bold tracking-tight">
              Lock <span className="text-lime-400">$39/mo forever</span> — 22% off Growth, for life.
            </h3>
            <p className="mt-2 text-sm text-emerald-100/80 max-w-xl">
              First 100 annual subscribers. Founder badge on your profile. Refer 3 paid subs → your price drops to <b className="text-lime-300">$29/mo</b> forever. Zero fine print.
            </p>
          </div>
          <div className="shrink-0">
            <button
              onClick={cta}
              data-testid="founding-banner-cta"
              className="inline-flex items-center gap-2 bg-lime-400 text-emerald-950 rounded-lg px-5 py-3 text-sm font-semibold hover:bg-lime-300 transition-all hover:-translate-y-0.5 shadow-lg shadow-lime-400/20"
            >
              Claim my Founder seat <ArrowRight className="h-4 w-4" />
            </button>
            <p className="text-[11px] text-emerald-100/60 mt-2 text-center">$468 billed annually · Cancel anytime</p>
          </div>
        </div>
      </div>
    </section>
  );
}
